export enum PaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CREDIT_CARD = 'CREDIT_CARD',
  CASH = 'CASH',
  CASH_ON_DELIVERY = 'CASH_ON_DELIVERY'
}
